export default __webpack_public_path__ + "static/media/print_pcd.f4d83649.svg";